import { useLocation } from 'react-router-dom';

// pages that stand on their own, like the one an email link opens. a modal opened meanwhile, such as the data
// model upgrade prompt, waits until the user moves on instead of covering the page
const PAGES_WITHOUT_MODALS = [/^\/verify-email\//];

export const useModalsAllowed = () => {
  const { pathname } = useLocation();
  return !PAGES_WITHOUT_MODALS.some((page) => page.test(pathname));
};
